import React, { useEffect, useState } from "react";

import {
  apiCall,
  apiCallResponse,
  apiExportToExcel,
} from "src/_apiConfig/apiCall";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import TableButtonTo from "../common/Table/TableButtonTo";
import {
  FilterContains,
  FilterContainsInsensitive,
} from "../common/FilterCondition";
import CommonList from "../common/CommonList";
import {
  CommonSearchExtra,
  SCInput,
  SCSelect,
  updateSearchStatus,
} from "../common/CommonSearch";
import Auth from "src/auth";

const BidderList = () => {
  const [items, setItems] = useState([]);

  const { authenticated } = Auth();
  const [usersData, setUserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [textField, settextField] = useState("emailId"); // table header Default Selected Column
  const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage

  // // Your default search model
  const SearchFilterModel = {
    emailId: "",
    companyName: "",
    mobile: "",
    tenderCategory: "",
    properityName: "",
    directorName: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  // useEffect(() => {
  //   getTenderCatDrop(true);
  //   // orderClick ? setorder("asc") : setorder("desc");
  //   getBidderList(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    getTenderCatDrop(true);
    setloading(true);
    resetPageLimit();
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getBidderList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getBidderList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    resetPageLimit();
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";

    filter = "&$filter=";

    filter = FilterContainsInsensitive(filter, "emailId", search.emailId);
    filter = FilterContainsInsensitive(
      filter,
      "companyName",
      search.companyName
    );

    filter = FilterContains(filter, "mobile", search.mobile);
    filter = FilterContains(
      filter,
      "companyCategoryName",
      search.tenderCategory
    );
    filter = FilterContainsInsensitive(
      filter,
      "directorName",
      search.properityName
    );

    if (filter === "&$filter=") {
      filter = "";
    }
    console.log("dddd", filter);
    return filter;
  };

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      emailId: search.emailId.trim(),
      companyName: search.companyName.trim(),
      mobile: search.mobile.trim(),
      companyCategoryName: search.tenderCategory.trim(),
      directorName: search.properityName.trim(),
    });
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`Bidder/getBidders?${filterManage()}`).then(
        (res) => {
          if (res.success) paggingManage(parseInt(res.data.length) || 0);
          else paggingManage(0, false);
        }
      );
    }
  };
  const getBidderList = async (firstRequest) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);
      await apiCallResponse(
        `Bidder/getBidders?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      )
        .then((res) => {
          if (res.success) {
            setUserData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          }
        })
        .finally(setloading(false));

      //pageLimit === 0 ? setdisabledprev(true) : setdisabledprev(false);
    }
  };
  const getTenderCatDrop = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`Company_Category`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setItems(distJsonobj);
    }
    setloading(false);
  };
  let scopedSlotsList = {
    EditBtn: (item, index) => {
      return (
        <TableButtonTo
          to={`/editbidderdetails/${item.userId}`}
          ButtonName={"Edit"}
        />
      );
    },
    viewBidderDetails: (item, index) => {
      return (
        <TableButtonTo
          to={`/bidderlistview/${item.userId}`}
          ButtonName={"View"}
        />
      );
    },
  };
  const fields = [
    {
      key: "emailId",
      _style: { width: "15%" },
      label: TableHeaderSet("Email Address", "emailId"),
    },
    {
      key: "companyName",
      label: TableHeaderSet("Company Name", "companyName"),
    },
    {
      key: "mobile",
      label: TableHeaderSet("Mobile", "mobile"),
    },

    {
      key: "companyCategoryName",
      label: TableHeaderSet("Tender Category", "companyCategoryName"),
    },
    {
      key: "directorName",
      label: TableHeaderSet("Proprietor Name", "directorName"),
    },
    {
      key: "emdAmount",
      label: TableHeaderSet("EMD Amount", "emdAmount"),
    },
    {
      key: "purchaseCapacity",
      label: TableHeaderSet("Purchase Capacity", "purchaseCapacity"),
    },
    {
      key: "biddingCapacity",
      label: TableHeaderSet("Bidding Capacity", "biddingCapacity"),
    },
    {
      key: "EditBtn",
      label: <div>Edit</div>,
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "viewBidderDetails",
      label: <div>View</div>,
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUserData([]);
  };
  const tenderCategoryList = items
    .sort((a, b) => a.categoryName.localeCompare(b.categoryName))
    ?.map((item) => ({
      value: item.categoryName,
      label: item.categoryName,
    }));
  const searchControl = (
    <>
      <SCInput
        label={"Email Address : "}
        name={"emailId"}
        value={search.emailId}
        onChange={updateSearch}
      />
      <SCInput
        label={"Company Name : "}
        name={"companyName"}
        value={search.companyName}
        onChange={updateSearch}
      />
      <SCInput
        label={"Mobile : "}
        name={"mobile"}
        value={search.mobile}
        onChange={updateSearch}
      />

      <SCSelect
        labelname="Tender Category"
        name="tenderCategory"
        value={search.tenderCategory}
        onChange={updateSearch}
        items={tenderCategoryList}
        isSelectShow={true}
      />
      <SCInput
        label={"Proprietor Name : "}
        name={"properityName"}
        value={search.properityName}
        onChange={updateSearch}
      />
    </>
  );

  const ReportListExcelUrl = `Bidder/ExportToExcel`;
  const ReportListExcelFileName = "BidderList.xls";
  // get Report List ExportToExcel
  const ExportToExcel = async () => {
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        ReportListExcelUrl,
        getdata(0, 0),
        ReportListExcelFileName
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };
  let additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isExportToExcelDisplay={true}
      isExporting={isExporting}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      ExportToExcel={ExportToExcel}
    />
  );
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Bidder List"
      loading={loading}
      tabBtn="Edit"
      path={`/editbidderdetails/`}
      additional={additional}
      //prev={() => setpageLimit(pageLimit - Number(itemPerPage))}
      //next={() => setpageLimit(pageLimit + Number(itemPerPage))}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      id="userId"
      scopedSlots={scopedSlotsList}
    />
  );
};

export default BidderList;

// Bidder/getBidders?$orderBy=emailId%20desc&$skip=3&$top=10
//   Bidder/getBidders?$filter=contains(emailId,'{aa}')%20emailId%20asc%20&$skip=0&$top=5
//  Bidder/getBidders?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${5}
